import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeServiceModel } from './symbols';

@Injectable()
export class TypesServiceService {
  readonly api = '/api/type-service';

  constructor(private http: HttpClient) {
  }

  getTypesServices(): Observable<TypeServiceModel[]> {
    return this.http.get<TypeServiceModel[]>(`${this.api}/`);
  }
}
